import { useCallback } from 'react';
import useEventEmitter from './useEventEmitter';
export const EVENT_TYPE = 'pointermove';
export const SERIES_SOURCE = 'series-key-highlight';
export default function useActiveSeriesKeyEmitter(eventType) {
  if (eventType === void 0) {
    eventType = EVENT_TYPE;
  }
  const emit = useEventEmitter();
  const emitActiveSeriesKey = useCallback((event, label) => emit === null || emit === void 0 ? void 0 : emit(eventType, event, SERIES_SOURCE, label), [emit]);
  return {
    emitActiveSeriesKey
  };
}